import { useEffect } from "react";
import { SITE } from "./siteConfig";

function setMetaTag(attr, key, content) {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setLinkTag(rel, href) {
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

/**
 * Проставляет title/description/canonical/OG-теги для текущей страницы.
 * Помогает поисковикам, выполняющим JS (Google), и правильному отображению
 * во вкладке браузера — но НЕ ботам соцсетей/мессенджеров: они не выполняют
 * JS и видят только статические теги из public/index.html.
 */
export default function useSeo({ title, description, path = "/", image, noindex = false }) {
    useEffect(() => {
        if (title) document.title = title;

        setMetaTag("name", "description", description);
        setMetaTag("name", "robots", noindex ? "noindex, follow" : "index, follow");

        const origin = window.location.origin;
        const url = `${origin}${path}`;
        setLinkTag("canonical", url);

        setMetaTag("property", "og:type", "website");
        setMetaTag("property", "og:site_name", SITE.brand);
        setMetaTag("property", "og:title", title);
        setMetaTag("property", "og:description", description);
        setMetaTag("property", "og:url", url);
        if (image) setMetaTag("property", "og:image", `${origin}${image}`);
    }, [title, description, path, image, noindex]);
}
